// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/a1b1af9592d5f0466e58.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"f00ced8774f13260cbae","129":"be9f06cc6afa2218704b","130":"6a34a45805bee0cbfcb6"}[chunkId] + ".chunk.js";
};